import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

function Toaster({ ...props }: ToasterProps) {
  return (
    <Sonner
      theme="light"
      toastOptions={{
        classNames: {
          toast: 'border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-800',
          success: 'border-green-500 text-green-900 dark:text-green-100',
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
